import { getApiUrl } from "../../../utils/getApiUrl";
import {
  isNonProdBuild,
  isProductionModeOn,
} from "../../../utils/productionMode";

/**
 * Whether this build talks to the production admin API. redesign and dev are
 * built against staging, whose database is a frozen copy with no live status
 * (ENG-2039), so the page says so instead of letting a snapshot read as live.
 */
export const isProdApi = (): boolean =>
  /(^|\/\/)admin\.actuateui\.net/.test(getApiUrl() ?? "");

/**
 * Whether "Preview with sample data" is offered (Jacob, K-14). redesign is for
 * internal testing, so staff on redesign and dev keep it; a production build
 * never shows it, and neither does production mode, where sample cards
 * blended into live data would read as real.
 */
export const samplePreviewAvailable = (): boolean =>
  isNonProdBuild() && !isProductionModeOn();

export const STAGING_DATA_NOTE =
  "Not production: site status, arm state and configuration here are staging's copy of the database and can be weeks old. Alerts are live. Check prod admin before acting on a status shown here.";

/** Set once the visitor acknowledges the staging-data notice. */
export const STAGING_NOTE_ACK_KEY = "troubleshooterStagingNoteAck";
